import { getSport8RefundAudit } from '../../../api/sport8Api'
import BookingDescription from '../../../components/bookings/booking-description/booking-description'
import AuthPermission from '../../../high-order-components/auth-permission'
import translate from '../../../i18n'
import { PermissionsEnum } from '../../../share-types'
import { ISport8RefundAudit } from '../share-type'
import { Button, Descriptions, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const Sport8RefundAudit = () => {
  const params = useParams()
  const bookingId = params?.id
  const [sport8RefundAudit, setSport8RefundAudit] = useState<ISport8RefundAudit>()

  useEffect(() => {
    getSport8RefundAudit(Number(bookingId)).then(res => {
      setSport8RefundAudit(res)
    })
  }, [])

  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <Descriptions
        styles={{ label: { alignItems: 'center', fontWeight: 600 } }}
        title={translate('sport8RefundAudits.integrationBookingInfo')}
        layout="vertical"
        bordered
        column={2}
        extra={
          <AuthPermission permission={PermissionsEnum.SPORT8_REFUND_AUDIT_WRITE}>
            <Button disabled type="primary">
              {translate('sport8RefundAudits.syncRefundAuditStatus')}
            </Button>
          </AuthPermission>
        }
      >
        <Descriptions.Item label={translate('booking.externalProvider')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.integratorBookingId}
        </Descriptions.Item>
        <Descriptions.Item label={translate('sport8RefundAudits.auditTradeNo')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.auditTradeNo}
        </Descriptions.Item>
        <Descriptions.Item label={translate('sport8RefundAudits.price')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.price}
        </Descriptions.Item>
        <Descriptions.Item label={translate('sport8RefundAudits.checkInCode')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.checkInCode}
        </Descriptions.Item>
        <Descriptions.Item label={translate('createdAt')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.createdAt}
        </Descriptions.Item>
        <Descriptions.Item label={translate('updatedAt')}>
          {sport8RefundAudit?.studioIntegrationBookingInfo.updatedAt}
        </Descriptions.Item>
      </Descriptions>
      {sport8RefundAudit?.booking && <BookingDescription booking={sport8RefundAudit.booking} />}
    </Space>
  )
}

export default Sport8RefundAudit
